export default __webpack_public_path__ + "static/media/tech_2.06edc92b.png";